<template>
  <div>
    <div class="row">
      <div class="col-3">
        <span @click="switchComponent('editCustomerOrder')">
          ویرایش
        </span>
      </div>
    </div>
    <!--<div class="modal detailModal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="workDetailModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            ...
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>-->
    <b-modal
      ref="detail-modal"
      id="detailModal"
      size="xl"
      :title="'جزئیات سفارش '+ orderDetail.productName"
      ok-title="بستن"
      ok-only
    >
      <div class="row mb-2">
        <div class="col-6" v-if="companySelected === false">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تامین کننده</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="company"
              :data="companyNames"
              :header="{label:'companyName'}"
              :mode="'edit'"
              :is-header="true"
              @onChange="onCompanyNameChange"
            ></vs-select>
          </div>
        </div>
        <div class="col-6" v-else>
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تامین کننده</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <input v-model="selectedCompanyName" type="text" class="form-control" readonly>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-4">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>محصولات</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="products"
              :data="productsName"
              :header="{label:'productName'}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="productSelectedVal"
              @onChange="onProductChange"
            ></vs-select>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تعداد</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <input v-model="productCount" type="text" class="form-control">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تاریخ تحویل</span>
              </div>
            </div>
            <date-picker v-if="mode!=='view'" format="jYYYY-jMM-jDD" @input="setDateFromDatePicker" ref="datePicker" :auto-submit="true" :min="currentDate">
              <slot>
                <input v-model="orderDate" class="form-control date-input" @focus="toggleDatePicker"
                       @click="toggleDatePicker" readonly placeholder="کلیک کنید">
              </slot>
            </date-picker>
          </div>
        </div>

        <div class="col-12 mt-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>توضیحات</span>
              </div>
            </div>
            <input v-model="productDescription" type="text" class="form-control">
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-12 text-center mt-2">
          <button class="btn iconed btn-secondary" id="btn-order" @click="addRowToTable"><i
            class="icon-bd-plus"></i><span>افزودن به جدول</span></button>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-12">
          <vs-table
            v-if="show"
            :params="params"
            :options="options"
          ></vs-table>
          <!--@onCreateHeaderActionClicked="openProductModal"-->
        </div>
      </div>



    </b-modal>
  </div>
</template>



<script>
    import VsTable from "../_framework/VsTable.vue";
    import EventBus from "../bus.js";
    import Products from "../pages/Products";
    import Moment from "moment-jalali";
    import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
    import VsSelect from "../_framework/VsSelect";
    import BaseService from "../_framework/api/BaseService.js";
    import BdSelectCompanyModal from "../components/BDSelectCompanyModal.vue";
    import BdProductOrderModal from "../components/BDProductOrderModal.vue";
    import {mapState, mapMutations, mapActions} from "vuex";
    import Vue from "vue";
    import {bus} from '../main';
    import Utils from "../_framework/utils/Utils.js";
    import * as $ from 'jquery';

    export default {
        name: "order-form",
        props: {
            orderDetail: Object,
            currentComp: {
                type: String,
            }
        },
        components: {
            VsTable,
            Moment,
            datePicker: DatePicker,
            VsSelect,
            BdSelectCompanyModal,
            BdProductOrderModal
        },
        data() {
            return {
                selectedCompanyName: '',
                companySelected: false,
                showCompany: false,
                productSelectedVal: null,
                disableButtonFlag: false,
                childOrderObject: {},
                ordersArray: [],
                serveName: '',
                serveCompanyId: 0,
                productSelectedName: '',
                productSelectedId: 0,
                productUnitId: 0,
                companyNames: [],
                products: {
                    data: []
                },
                productsName: [],
                productCount: 0,
                productDescription: '',

                model: {},
                hasAccess: true,
                access: {},
                show: true,
                orderDate: null,
                voucherTitles: [],
                orderModel: {
                    orders: [],
                },
                rowsPrice: 0,
                selectedCompany: {},
                selectedProduct: {},
                productOrderModel: {},
                server: {
                    name: localStorage.getItem("company")
                },
                receiver: {},
                partyType: "",
                currentDate: Moment().format("jYYYY/jMM/jDD"),
                params: {
                    entity: "voucher",
                    list: [],
                    headers: {
                        /*id: {
                          title: "ردیف",
                          type: "number",
                          rowAlignment: "center",
                          grow: 0.25
                        },*/
                        productName: {
                            title: "نام محصول",
                            type: "text",
                            rowAlignment: "center"
                        },
                        ordersCount: {
                            title: "تعداد",
                            type: "text",
                            rowAlignment: "center"
                        },
                        serveName: {
                            title: "تامین کننده",
                            type: "number",
                            rowAlignment: "center"
                        },
                        createDate: {
                            title: "تاریخ تحویل",
                            type: "text",
                            rowAlignment: "center",
                            formatGregorianDateToJalaali: true
                        }
                    }
                },
                options: {
                    dataSourceType: "store",
                    hasActions: false,
                    onRowClicked: row => {
                    },
                    hasActionsInHeader: true,
                    clickableRows: true,
                    onCreateHeaderActionClicked: false,
                    onEditClicked: (row, context) => {
                        this.productOrderModel = row;
                        this.productOrderModel.mode = "edit";
                        this.openProductDetailModal();
                    },
                    onRowDoubleClicked: row => {
                        this.productOrderModel = row;
                        this.productOrderModel.mode = "view";
                        this.openProductDetailModal();
                    },
                    beforeDeleteEntity: input => {
                        this.deleteOrdersTableRow(input.id);
                        return null;
                    }
                }
            };
        },
        mounted() {

            this.getCompanies();
        },
        methods: {
            switchComponent(comp) {
                this.$refs['detail-modal'].show()
                this.getOrderDetail();
                bus.$emit('switchComp', comp);
            },
            getOrderDetail() {
                // console.log(this.orderId)
                new BaseService('CustomerOrders', `/GetOrderDetailWorks/${this.orderDetail.id}`).getList().then((response) => {
                    // console.log(response.data)
                    this.innerWorkDetails = response.data;
                    this.workDetail = this.innerWorkDetails.works;
                }).catch((error) => {
                    console.log(error)
                })
            },
            resetOrderForm() {
                this.$refs.products.$data.selectedValue = null;
                // this.$refs.company.$data.selectedValue = null;
                this.productCount = null;
                this.orderDate = null;
                this.productDescription = null
            },
            sendObjectToParent() {
                this.childOrderObject = {
                    serveCompanyId: this.serveCompanyId,
                    serveName: this.serveName,
                    description: this.productDescription,
                    orders: this.ordersArray,
                };
                this.$emit('add-order-object', this.childOrderObject);
                this.$emit('createNewOrder', this.resetOrderForm());
                this.$emit('btn-order', this.disableButtonFlag);
            },
            addRowToTable() {
                if (this.productCount !== 0 && this.orderDate !== null) {
                    this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
                        productName: this.productSelectedName,
                        ordersCount: this.productCount,
                        serveName: this.serveName,
                        createDate: this.orderDate,
                    });
                    let model = {
                        productId: this.productSelectedId,
                        deliveryDate: this.orderDate,
                        description: this.productDescription,
                        unitVal: this.productCount,
                        unitId: this.productUnitId
                    };
                    this.ordersArray.push(model);
                    this.sendObjectToParent();

                    this.resetOrderForm();
                } else if (this.productCount === 0 || this.productCount === null) {
                    this.$noty.error("لطفا تعداد مورد نظر را وارد کنید");
                } else if (this.orderDate === null || this.orderDate === undefined) {
                    this.$noty.error("تاریخ تحویل الزامی است");
                }
            },
            setDateFromDatePicker(date) {
                this.orderDate = date;
                this.orderModel.orderDate = date;
            },
            toggleDatePicker() {
                if (this.mode === "view") {
                    return;
                }
                this.$refs.datePicker.togglePicker();
            },
            onCompanyNameChange(val) {
                if (val !== null && val !== undefined) {
                    this.selectedCompanyName = val.companyName;
                    this.companySelected = true;
                    this.getProducts();
                    this.serveName = val.companyName;
                    this.serveCompanyId = val.id;
                }

            },
            onProductChange(val) {
                if (val !== null && val !== undefined) {
                    this.productSelectedName = val.productName;
                    this.productSelectedId = val.id;
                    this.productUnitId = val.unit.id;
                }

                // console.log(this.$refs.products);
                //  for (let item of this.$refs.products.data) {
                //    // console.log(this.$refs.products.data)
                //    this.productSelectedName = item.productName;
                //    this.productSelectedId = item.id;
                //    this.productUnitId = item.unit.id;
                //  }


            },
            getCompanies() {
                new BaseService('Company', '/GetAllParents').getList().then((response) => {
                    // console.log(response.data);
                    this.companyNames = response.data;
                }).catch((error) => {
                    console.log(error)
                })
            },
            deleteOrdersTableRow(id) {
                this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", id);
                this.orderModel.orders = this.orderModel.orders.filter(o => {
                    return o.id !== id;
                });
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 1);
            },
            goBack() {
                this.$router.push({name: "سفارش فروش"});
            },
            voucherTitleSelect(prop, data) {
                this.orderModel.documentTypeId = data.id;
            },
            onCompanyDoubleClicked() {
                this.onSelectCompany();
                if (this.$refs && this.$refs.selectCompany) {
                    this.$refs.selectCompany.hide();
                }
            },
            onSelectCompany(e) {
                this.orderModel.serveCompanyId = this.selectedCompany.id;
                this.orderModel.serveName = this.selectedCompany.name;
            },
            selectCompany(data) {
                this.selectedCompany = data;
            },
            openCompanyModal(partyType) {
                if (this.mode === "view") {
                    return;
                }
                this.partyType = "server";
                this.$refs.selectCompany.show();
            },
            selectProduct(prod) {
                this.selectedProduct = prod;
                this.productOrderModel = {};
                this.productOrderModel.productName = prod.productName;
                this.productOrderModel.productId = prod.id;
                this.productOrderModel.unit = prod.unit;
                this.productOrderModel.stock = prod.stock;
                this.productOrderModel.type = "Create";
            },
            changepvmData(pvmData) {
                this.productOrderModel = pvmData;
            },
            openProductDetailModal(prod) {
                this.$refs.modal.hide();
                let ComponentClass = Vue.extend(BdProductOrderModal);
                let pdModal = new ComponentClass({
                    propsData: {
                        model: this.productOrderModel
                    }
                });
                pdModal.$mount();
                this.$refs.container.appendChild(pdModal.$el);
                setTimeout(() => {
                    pdModal.openModal();
                }, 200);
                pdModal.$on("onProductOrderModalOk", mode => {
                    if (mode === "create") {
                        this.addOrderRow();
                    } else if (mode === "update") {
                        this.updateOrderRow();
                    }
                });
            },
            getProducts() {
                new BaseService('Products', '/GetSellableProducts').getList().then((response) => {
                    // console.log(response.data)
                    this.productsName = response.data;
                    /*for (let item of this.products) {
                      this.productsName.push(item.productName)
                    }*/


                }).catch((error) => {
                    console.log(error)
                })
            },
            /*openProductModal() {
              this.getProducts();
              let ComponentClass = Vue.extend(Products);
              let _products = new ComponentClass({
                propsData: { isSelectMode: "true" },
                store: this.$store
              });
              _products.$mount();
              if (this.$refs.productsContainer.hasChildNodes()) {
                this.$refs.productsContainer.removeChild(
                  this.$refs.productsContainer.childNodes[0]
                );
              }
              this.$refs.productsContainer.appendChild(_products.$el);
              if (this.$refs && this.$refs.modal) {
                this.$refs.modal.show();
              }
              _products.$on("onRowSelect", row => {
                this.selectProduct(row);
              });
              _products.$on("onRowDoubleClicked", row => {
                this.openProductDetailModal(row);
              });
            },*/
            toggleStartDatePicker() {
                this.$refs.datePicker.togglePicker();
            },
            hideModal() {
                this.$refs.modal.hide();
            },
            addOrderRow(_data) {
                let data = _data || JSON.parse(JSON.stringify(this.productOrderModel));
                this.addOrderProducts(data);
            },
            updateOrderRow(_data) {
                let data = _data || JSON.parse(JSON.stringify(this.productOrderModel));
                this.updateOrderProducts(data);
            },
            /*addOrderProducts(data) {
              let number = data.number || data.unitVal;
              number = number * 1;
              this.orderModel.orders.push({
                productId: data.productId,
                unitId: data.unit ? data.unit.id : data.unitId,
                unitVal: number,
                deliveryDate: data.deliveryDate,
                description: data.description
              });
              this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
                productId: data.productId,
                unitId: data.unit ? data.unit.id : data.unitId,
                productName: data.productName,
                unit: data.unitName || data.unit,
                number: number,
                deliveryDate: data.deliveryDate,
                description: data.description
              });
              this.refreshOrderProductsTable();
            },*/
            updateOrderProducts(data) {
                // console.log(data);

                let number = data.number || data.unitVal;
                number = number * 1;
                this.orderModel.orders = this.orderModel.orders.map(om => {
                    if (om.id === data.id) {
                        om.productId = data.productId;
                        om.unitId = data.unitId || data.unit.id;
                        om.unitVal = number;
                        om.deliveryDate = data.deliveryDate;
                        om.description = data.description;
                    }
                    return om;
                });
            },
            refreshOrderProductsTable() {
                let id = 0;
                this.vsTableFeed.map(p => {
                    id = id + 1;
                    p.id = id;
                });
                id = 0;
                this.orderModel.orders.map(p => {
                    id = id + 1;
                    p.id = id;
                });
            },
            submit() {
                this.orderModel.receiverName = "first";
                this.orderModel.receiverOutSourceId = 1;
                this.orderModel.orders.map(o => {
                    /*o.deliveryDate = Moment(o.deliveryDate, "jYYYY-jMM-jDD").format(
                      "YYYY/MM/DD"
                    );*/
                });
                if (this.mode === "create") {
                    this.orderModel.date = this.currentDate;
                    new BaseService("orders").create(this.orderModel).then(rs => {
                        this.goBack();
                    });
                } else if (this.mode === "edit") {
                    new BaseService("orders").update(this.orderModel).then(rs => {
                        this.goBack();
                    });
                }
            }

        },

        beforeMount() {
            this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
            this.options.access = checkAccess(this.$route.path);
            this.hasAccess = !!this.options.access;
            if (this.$route.query._mode === "view") {
                this.options.hasActions = false;
                this.options.hasActionsInHeader = false;
            }
            if (this.$route.query.id) {
                new BaseService("orders").getById(this.$route.query.id).then(rs => {
                    this.model = rs.data;
                    this.orderModel.orders = [];
                    if (this.model) {
                        this.model.date = this.model.date.substring(0, 10);
                        this.orderModel.id = this.model.id;
                        this.orderModel.date = this.model.date;
                        this.model.orders.map(o => {
                            /* o.deliveryDate = Moment(o.deliveryDate, "YYYY-MM-DD").format(
                               "jYYYY-jMM-jDD"
                             );*/
                            this.addOrderRow(o);
                        });
                        this.selectedCompany.name = this.model.serveName;
                        this.orderModel.serveName = this.model.serveName;
                        this.orderModel.serveCompanyId = this.model.serveCompanyId;
                    }
                });
            }
        },
        created() {
            EventBus.$on("selectTreeNode", data => {
                data.type = "company";
                this.selectedCompany = data;
            });
        },
        computed: {
            ...mapState(["vsTableFeed", "tableRowIndex"]),
            mode() {
                return this.$route.query._mode;
            }
        },
        watch: {
            vsTableFeed(val) {
                this.refreshOrderProductsTable();
            }
        }
    };
</script>

<style scoped>
  .back-to-table {
    display: flex;
    justify-content: flex-end;
    color: #9370db;
  }

  .back-to-table i {
    font-size: 1.5rem;
  }
</style>
